import React, {Component} from "react";
import _, {DebouncedFunc} from "lodash";
import Select from "components/common/select/Select.component";
import { FormField } from "components/common/FormField.component";
import translate from "components/translations/translations.wrapper.jsx";
import {
    AdvancedSearchInputState,
    AdvancedSearchInputProps,
    AdvancedSearchInputResponse,
    AdvancedSearchInputResponseItem
} from "types/advancedSearchInput";

/*
* https://github.com/phunware/react-select because react-select doesn't trigger onMenuScrollToBottom
* */

const COMMON_PARAMS = {
    prefix: "",
    page: 1,
    rows: 20,
    usedInIndexOnly: true,
    showInactive: true,
};


export class AdvancedSearchInput extends Component<AdvancedSearchInputProps, AdvancedSearchInputState> {
    requests: any[];
    inputElement: React.RefObject<unknown>;
    typedValue: string;
    private getOptionsWithDelay: DebouncedFunc<(event: any, func:Function, dimension: string, value: string) => void>;

    constructor(props: AdvancedSearchInputProps) {
        super(props);
        this.state = {
            options: [],
            selectedAccount: "",
            currentPage: COMMON_PARAMS.page,
            records: 1,
            isLoading: false,
        };
        this.requests = [];
        this.getOptions = this.getOptions.bind(this);
        this.filterOptions = this.filterOptions.bind(this);
        this.getOptionsWithDelay = _.debounce((_event, func, dimension, value) => {
            this.filterOptions(func, dimension, value);
        }, 1000);
        this.cancelCalls = this.cancelCalls.bind(this);
        this.scroll = this.scroll.bind(this);
        this.callBackend = this.callBackend.bind(this);
        this.focus = this.focus.bind(this);
        this.inputElement = React.createRef();
    }


    focus() {
        // @ts-ignore
        this.inputElement.focus();
    }

    filterOptions(func: Function, dimension: string, value: string) {
        if (this.state.records > 20) {
            this.getOptions(func, dimension, value);
        }
    }

    componentWillUnmount() {
        this.cancelCalls();
        this.getOptionsWithDelay.cancel();
    }

    cancelCalls() {
        this.requests.forEach(p => {
            if (p)
                p.cancel();
        });
        this.requests = [];
    }

    callBackend(functionName: Function, data: any, dimension: string) {
        functionName(data, dimension, this.props.companyId).then((response: AdvancedSearchInputResponse) => {
            let values = response.rows;
            if (values && values.length > 0) {
                if (this.props.hasAny)
                    values.unshift({ number: -99, name: this.props.translate("generic.genericAny"), active: true });
                if (this.props.hasUnassigned)
                    values.unshift({ number: -1, name: this.props.translate("generic.unassigned"), active: true });
            }

            const results = values.map((item: AdvancedSearchInputResponseItem) => {
                return {
                    label: (item.number > 0 || typeof item.number === "string" ? (item.number + " - ") : "") + item.name,
                    value: item.number,
                    color: (item.active) ? "black" : "lightgrey",
                };
            });
            this.setState({
                options: results,
                isLoading: false,
                currentPage: response.page,
                records: response.records,
            });
        });
    }

    getOptions(func: Function, dimension: string, value: string) {
        this.setState({
            options: [],
            isLoading: true,
        }, () => {
            if (typeof dimension === "undefined")
                return [];

            let data = Object.assign({}, COMMON_PARAMS);
            data.usedInIndexOnly = this.props.usedInIndexOnly === false ? false : COMMON_PARAMS.usedInIndexOnly;

            if (value) {
                data.prefix = value;
            }

            this.requests.push(this.callBackend(func, data, dimension));
        });
    }

    scroll(func: Function, dimension: string, value: string) {
        if (this.state.records > this.state.options.length) {
            let data = Object.assign({}, COMMON_PARAMS);
            if (this.props.usedInIndexOnly === false)
                data.usedInIndexOnly = false;
            if (value)
                data.prefix = this.typedValue;
            data.page = this.state.currentPage + 1;

            let self = this;

            return func(data, dimension, this.props.companyId).then((response: AdvancedSearchInputResponse) => {
                const results = response.rows.map((item: AdvancedSearchInputResponseItem) => {
                    return {
                        label: "[" + item.number + "] " + item.name,
                        value: item.number,
                        color: (item.active) ? "black" : "lightgrey",
                    };
                });
                this.setState({
                    options: Object.assign([], self.state.options).concat(results),
                    currentPage: response.page,
                    records: response.records,
                });
            });
        }
    }


    render() {
        return (
            <div className={"col-md-3"}>
                <div className="col-md-12 p-0 row m-0">
                        <FormField
                            id={"search" + this.props.name}
                            label={this.props.name}
                            disabled={this.props.disabled}
                        >
                            <Select
                                isClearable={true}
                                ref={(element: any) => {
                                    this.typedValue = element ? element.state.inputValue : "";
                                    this.inputElement = element;
                                }}
                                isDisabled={this.props.disabled}
                                onBlurResetsInput={false}
                                onCloseResetsInput={false}
                                isSearchable={true}
                                isLoading={this.state.isLoading}
                                value={this.props.selectedValue}
                                placeholder={this.props.placeholder}
                                menuPlacement={(this.props.menuPlacement as 'auto' | 'top' | 'bottom') || "bottom"}
                                menuPosition={this.props.menuPosition === "fixed" ? "fixed" : "absolute"}
                                tabIndex={this.props.tabIndex}
                                autoFocus={this.props.autoFocus}
                                options={this.state.options}
                                tabSelectsValue={this.props.tabSelectsValue ? this.props.tabSelectsValue : false}
                                onMenuOpen={this.getOptions.bind(this, this.props.type, this.props.dimension)}
                                onInputChange={this.getOptionsWithDelay.bind(null, this, this.props.type, this.props.dimension)}
                                onChange={this.props.onChange.bind(this)}
                                onMenuScrollToBottom={this.scroll.bind(this, this.props.type, this.props.dimension)}
                                closeMenuOnSelect={true}
                                translate={this.props.translate}
                            />
                        </FormField>
                </div>
            </div>
        );
    }
}

const withTranslations = translate(AdvancedSearchInput);
export default withTranslations;
